module.exports = __webpack_public_path__ + "img/info.379c6847.svg";